import { render, staticRenderFns } from "./Deco.vue?vue&type=template&id=60cfc769&scoped=true&"
import script from "./Deco.vue?vue&type=script&lang=js&"
export * from "./Deco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cfc769",
  null
  
)

export default component.exports